export default __webpack_public_path__ + "static/media/5_self_assessments.c19513fd.png";